import * as z from "zod/v4";

export const deleteWarehouseProduct = {
  name: "deleteWarehouseProduct" as const,
  input: z.object({ productId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
